import React, { useRef } from 'react';
import { useOnScreen } from './useOnScreen';

const PLACEHOLDER_IMAGE_URL = 'http://cdn.auroraelec.ru/static/250px.svg';

const createInnerHTML = (productId, productPartNumber, productManufacturerName, productAttributeValue, productAttributeKey, imageSrc, isVisible, packageType, stockQuantity, orderQuantity, description, categoryName) => {
    let result = '';

    // Обёртка для визуального выравнивания под макет
    result += '<div class="search-hint__row">';

    // Чтобы исключить "прыжок" верстки: всегда рендерим колонку изображения у всех подсказок,
    // но по умолчанию показываем заглушку. При ошибке загрузки реального изображения возвращаемся к заглушке.
    // isVisible оставлен, чтобы не грузить реальные картинки вне viewport.
    const safeSrc = (isVisible && imageSrc) ? imageSrc : PLACEHOLDER_IMAGE_URL;
    result += `
        <div class="search-hint__col search-hint__col--image">
            <img
                class="search-options__image"
                onerror="this.onerror=null; this.src='${PLACEHOLDER_IMAGE_URL}';"
                src="${safeSrc}"
                alt="${productPartNumber || productAttributeValue}"
            />
        </div>
    `;

    // Контент
    result += '<div class="search-hint__col search-hint__col--content">';
    result += '<div class="search-options__content">';

    if (productPartNumber) {
        const categoryText = categoryName || '';
        result += `
            <div class='search-hint__title'>
                <span class='search-options__name'>${productPartNumber} <span class='mob-manufacturer'>${productManufacturerName}</span></span>
                ${categoryText ? `<span class='search-options__key'>${categoryText}</span>` : ''}
            </div>
        `;
    } else {
        const categoryText = categoryName || '';
        result += `
            <div class='search-hint__title'>
                <span class='search-options__name'>${productAttributeValue} <span class='mob-manufacturer'>${productAttributeKey}</span></span>   
                ${categoryText ? `<span class='search-options__key'>${categoryText}</span>` : ''}
            </div>
        `;
    }

    // Строка с колонками «Корпус» и «Описание» и их подзаголовками
    result += '<div class="search-options__details">';
    // Колонка Корпус с заголовком
    result += '<div class="search-options__details-col">'
        + '<div class="search-options__details-title">Корпус</div>'
        + `<div class="search-options__package">${packageType ? packageType : ''}</div>`
        + '</div>';
    // Колонка Описание с заголовком
    result += '<div class="search-options__details-col">'
        + '<div class="search-options__details-title">Описание</div>'
        + `<div class="search-options__description">${description ? description : ''}</div>`
        + '</div>';

    result += '</div>'; // details
    result += '</div>'; // content
    result += '</div>'; // col content
    result += '</div>'; // row

    return result;
};



const createAllFiledsString = (productId, productPartNumber, productManufacturerId, productManufacturerName, productAttributeValue, productAttributeKey) => {
    return productId + productPartNumber + productManufacturerId + productManufacturerName + productAttributeValue + productAttributeKey;
};

const makeFilterValue = (productAttributeKey, productAttributeValue) => {
    const result = [{[productAttributeKey]: productAttributeValue}];
    return JSON.stringify(result);
};

const HintItem = ({productId, productPartNumber, productManufacturerId, productManufacturerName, 
    productAttributeValue, productAttributeKey, packageType, stockQuantity, orderQuantity, description, categoryName, imageSrc, CustomRouter}) => {
    const ref = useRef(null);
    const isVisible = useOnScreen(ref);

    const routeToThePageFunction = () => {
        if(productPartNumber) {
            CustomRouter.navigate(`/product/${productId}`);
            // Очищаем подсказки после перехода (без доп. запросов)
        } else {
            CustomRouter.navigate(`/search/?q=${productAttributeValue}&filter=${makeFilterValue(productAttributeKey, productAttributeValue)}`);
        }
    };

    return (
        <li key={createAllFiledsString(productId, productPartNumber, productManufacturerId, productManufacturerName, productAttributeValue, productAttributeKey)}
            className='search-options__item' onClick={routeToThePageFunction}
            ref={ref}
            id={productId}
            dangerouslySetInnerHTML={{ __html: createInnerHTML(productId, productPartNumber, productManufacturerName, productAttributeValue, productAttributeKey, imageSrc, isVisible, packageType, stockQuantity, orderQuantity, description, categoryName)}}></li>
    );
};

export default HintItem;
